/**
 * @fileoverview Org portal — a class's own details.
 *
 * Name, description, room and the circumstances an instructor needs to know
 * before they turn up. The program's ADDRESS is not here: it is a program
 * fact shared by every class, edited on the program's Settings tab
 * (`ProgramLocationSettings`), and the class page's publish gate points at it.
 */

import { useState } from "react";
import { toast } from "sonner";
import orgApi, { getOrgErrorMessage } from "@/lib/orgApi";
import { Button, Card, SectionHeader } from "@/components/studio/primitives";

const input = "w-full rounded-xl border border-[var(--studio-divider-strong)] bg-[var(--studio-raised)] px-3 py-2 text-[var(--text-primary)]";

export default function ClassDetailsCard({ cls, onChanged }) {
  const [details, setDetails] = useState({ name: cls.name || "", description: cls.description || "", room: cls.room || "", notes: cls.notes || "" });
  const [busy, setBusy] = useState(false);
  const save = async (event) => {
    event.preventDefault(); setBusy(true);
    try {
      await orgApi.put(`/org/classes/${cls.class_id}`, details);
      toast.success("Class details saved"); onChanged?.();
    } catch (error) { toast.error(getOrgErrorMessage(error, "Couldn't save class details")); }
    finally { setBusy(false); }
  };
  return <>
    <SectionHeader>Class details</SectionHeader>
    <Card className="mb-6" data-testid="class-details">
      <form onSubmit={save} className="space-y-4">
        <p className="text-sm text-[var(--text-secondary)]">Room and circumstances are optional. Everyone assigned to teach this class can see them.</p>
        {[["name", "Class name"], ["description", "Description"], ["room", "Room"], ["notes", "Unique circumstances"]].map(([key, label]) =>
          <label key={key} className="block text-sm text-[var(--text-secondary)]">{label}
            {key === "notes" ? <textarea className={input} value={details[key]} maxLength={5000} onChange={e => setDetails({ ...details, [key]: e.target.value })} />
              : <input className={input} value={details[key]} required={key === "name"} maxLength={key === "description" ? 280 : key === "name" ? 120 : 200} onChange={e => setDetails({ ...details, [key]: e.target.value })} />}
          </label>)}
        <Button type="submit" disabled={busy}>Save details</Button>
      </form>
    </Card>
  </>;
}
